import { useTranslation } from 'react-i18next';

import { CustomModal, CustomModalProps } from 'components/shared';
import { useErrorDescriptions } from 'constants/errorDescriptions';
import { useModal } from 'hooks/useModal';
import { HTTPService } from 'service';
import { logNetworkError } from 'utils/logNetworkError';

import styles from './DeactivateClientModal.module.css';

interface DeactivateClientModalProps extends CustomModalProps {
   clientId: string;
   setDeactivatedUserInfo: React.Dispatch<React.SetStateAction<boolean>>;
   setCannotDeactivateClientModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const DeactivateClientModal = ({
   clientId,
   setDeactivatedUserInfo,
   setCannotDeactivateClientModal,
   onClose,
   ...props
}: DeactivateClientModalProps) => {
   const { t } = useTranslation();
   const { isLoading, errorInfo, setIsLoading, setErrorInfo, closeModalHandler } = useModal({
      onClose,
   });

   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const deactivateUser = () => {
      setIsLoading(true);
      HTTPService.deactivateUser(clientId)
         .then(() => {
            setDeactivatedUserInfo(true);
         })
         .catch(err => {
            logNetworkError(err);
            if (err.response.data.code === 'USER_HAS_ORDERS') {
               setCannotDeactivateClientModal(true);
            } else {
               setErrorInfo(DEFAULT_ERROR_DESCRIPTIONS.UNKNOWN);
            }
         })
         .finally(() => {
            closeModalHandler();
            setIsLoading(false);
         });
   };

   return (
      <CustomModal
         {...props}
         title={t('deactivate_client.title')}
         icon="USER_OFF"
         error={errorInfo}
         isLoading={isLoading}
         leftSideModalContent
         onClose={closeModalHandler}
         primaryButtonProps={{
            text: t('deactivate_client.title'),
            variant: 'filled-danger',
            onClick: deactivateUser,
         }}
         secondaryButtonProps={{
            text: t('common.cancel'),
            variant: 'outlined-danger',
            onClick: closeModalHandler,
         }}
      >
         <div className={styles.modalContent}>
            <p>{t('deactivate_client.intro')}</p>
            <ul>
               <li>{t('deactivate_client.point_1')}</li>
               <li>{t('deactivate_client.point_2')}</li>
               <li>{t('deactivate_client.point_3')}</li>
            </ul>
            <p className={styles.actionInfo}>{t('cancel_pallet_report_modal.irreversible')}</p>
            <p>{t('sendToSettlement.confirmationQuestion')}</p>
         </div>
      </CustomModal>
   );
};
export default DeactivateClientModal;
